var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disabled)?_c('div',{staticClass:"jeecg-form-container-disabled"},[_c('fieldset',{attrs:{"disabled":""}},[_vm._t("default")],2)]):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }